import { makeAutoObservable } from 'mobx';
import { getUser, login, logout } from '../services/api';
import { deleteToken, getToken, saveToken } from '../services/token';

class UserStore {
  isLoggedIn = false;

  token = null;

  user = {};

  constructor() {
    makeAutoObservable(this);
  }

  async checkLogin() {
    try {
      const token = getToken();

      if (token == null) {
        return false;
      }

      const response = await getUser(token);
      this.user = response.data.data;
      this.token = token;
      this.isLoggedIn = true;

      return true;
    } catch (e) {
      deleteToken();
      return false;
    }
  }

  async login(email, password) {
    try {
      deleteToken();

      const response = await login(email, password);

      this.token = response.data.data.token;
      this.user = response.data.data.user;
      this.isLoggedIn = true;

      saveToken(this.token);

      return true;
    } catch (e) {
      return false;
    }
  }

  async logout() {
    try {
      await logout(getToken());
      deleteToken();
      this.token = null;
      this.user = {};
      this.isLoggedIn = false;
      return true;
    } catch (e) {
      return false;
    }
  }
}

export default UserStore;
